import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

function fmt(n) {
  if (n >= 10000000) return `₹${(n/10000000).toFixed(1)}Cr`;
  if (n >= 100000)   return `₹${(n/100000).toFixed(1)}L`;
  return `₹${Number(n).toLocaleString('en-IN')}`;
}

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{
      background: '#fff', border: '1px solid #f0e8e5', borderRadius: 8,
      padding: '8px 12px', fontSize: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    }}>
      <div style={{ color: '#888', marginBottom: 4 }}>{label}</div>
      <div style={{ color: '#6B1C2A', fontWeight: 600 }}>{fmt(payload[0]?.value)}</div>
    </div>
  );
};

export default function TrendChart({ data }) {
  const chartData = data.map(d => ({
    date: new Date(d.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }),
    value: d.collateral_value,
  }));

  return (
    <div style={{ background: '#fff', border: '1px solid #f0e8e5', borderRadius: 10, padding: '14px 16px', marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ fontSize: 10, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          Portfolio Value Trend
        </div>
        <div style={{ fontSize: 10, color: '#888' }}>Fortnightly Portfolio Value</div>
      </div>
      <ResponsiveContainer width="100%" height={130}>
        <AreaChart data={chartData} margin={{ top: 4, right: 4, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="trendGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#6B1C2A" stopOpacity={0.18} />
              <stop offset="100%" stopColor="#6B1C2A" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f5f0ee" vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 9, fill: '#aaa' }} axisLine={false} tickLine={false} />
          <YAxis hide={true} />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone" dataKey="value"
            stroke="#6B1C2A" strokeWidth={2}
            fill="url(#trendGrad)"
            dot={{ r: 3, fill: '#6B1C2A', strokeWidth: 0 }}
            activeDot={{ r: 5, fill: '#6B1C2A' }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
